import { render, staticRenderFns } from "./IndicadoresProceso.vue?vue&type=template&id=0a165486&"
import script from "./IndicadoresProceso.vue?vue&type=script&lang=js&"
export * from "./IndicadoresProceso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports